import React from 'react';
import { useTheme } from 'styled-components';
import { Skeleton } from '@mui/material';
import { SkeletonWrapper, SkeletonColumn } from './styles';

const KanbanSkeleton: React.FC = () => {
  const theme = useTheme();
  const skeletonColor = theme.colors.cardBorder;

  return (
    <>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={50}
        sx={{
          marginBottom: '1rem',
          borderRadius: '8px',
          backgroundColor: skeletonColor
        }}
      />

      <SkeletonWrapper>
        {[...Array(5)].map((_, index) => (
          <SkeletonColumn key={index}>
            <Skeleton
              variant="text"
              width="70%"
              height={20}
              sx={{
                marginBottom: '1rem',
                backgroundColor: skeletonColor
              }}
            />

            {[...Array(5)].map((_, cardIndex) => (
              <Skeleton
                key={cardIndex}
                variant="rectangular"
                width="100%"
                height={80}
                sx={{
                  borderRadius: '8px',
                  marginBottom: '0.5rem',
                  backgroundColor: skeletonColor
                }}
              />
            ))}
          </SkeletonColumn>
        ))}
      </SkeletonWrapper>
    </>
  );
};

export default KanbanSkeleton;
